export const PREVIOUS_PAYMENT_URL = "PREVIOUS_PAYMENT_URL"